(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["horoscope-benefits"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    var wrapper = document.querySelector('.horoscope-benefits');
    var items = document.querySelectorAll('.horoscope-benefits__item');
    if (!items.length || !wrapper) return;
    var targetId = wrapper.getAttribute('data-scroll-target') || 'horoscope-subscribe';
    var target = document.getElementById(targetId);
    if (!target) return;

    function smoothScrollTo(element) {
      var headerOffset = 100;
      var elementPosition = element.getBoundingClientRect().top;
      var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      var startPosition = window.pageYOffset;
      var distance = offsetPosition - startPosition;
      var duration = 1200;
      var startTime = null;

      function easeInOutCubic(t) {
        return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
      }

      function animation(currentTime) {
        if (startTime === null) startTime = currentTime;
        var elapsed = currentTime - startTime;
        var progress = Math.min(elapsed / duration, 1);
        window.scrollTo(0, startPosition + distance * easeInOutCubic(progress));
        if (elapsed < duration) requestAnimationFrame(animation);
      }

      requestAnimationFrame(animation);
    }

    items.forEach(function (item) {
      item.addEventListener('click', function () {
        smoothScrollTo(target);
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["horoscope-cta-button"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.horoscope-cta-button__btn[data-scroll-to]').forEach(function (button) {
      if (button.dataset.scrollInitialized === 'true') return;

      button.dataset.scrollInitialized = 'true';

      button.addEventListener('click', function () {
        const targetId = this.getAttribute('data-scroll-to');
        const targetElement = document.getElementById(targetId);

        if (!targetElement) return;

        const headerOffset = 80;
        const elementPosition = targetElement.getBoundingClientRect().top;
        const offsetPosition =
          elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["member-audio-player"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const players = document.querySelectorAll('[data-audio-player]');

    players.forEach(player => {
      const audio = player.querySelector('[data-audio-element]');
      const playBtn = player.querySelector('[data-play-btn]');
      const progress = player.querySelector('[data-progress]');
      const progressBar = player.querySelector('[data-progress-bar]');
      const currentTimeEl = player.querySelector('[data-current-time]');
      const durationEl = player.querySelector('[data-duration]');

      if (!audio) return;

      // Format time helper
      function formatTime(seconds) {
        const mins = Math.floor(seconds / 60);
        const secs = Math.floor(seconds % 60);
        return `${mins}:${secs.toString().padStart(2, '0')}`;
      }

      // Play/Pause
      playBtn.addEventListener('click', function() {
        if (audio.paused) {
          // Pause all other players
          document.querySelectorAll('[data-audio-element]').forEach(a => {
            if (a !== audio) {
              a.pause();
              a.closest('[data-audio-player]').classList.remove('audio-player--playing');
            }
          });
          audio.play();
          player.classList.add('audio-player--playing');
        } else {
          audio.pause();
          player.classList.remove('audio-player--playing');
        }
      });

      // Update duration when metadata loaded
      audio.addEventListener('loadedmetadata', function() {
        durationEl.textContent = formatTime(audio.duration);
      });

      // Update progress
      audio.addEventListener('timeupdate', function() {
        const percent = (audio.currentTime / audio.duration) * 100;
        progressBar.style.width = percent + '%';
        currentTimeEl.textContent = formatTime(audio.currentTime);
      });

      // Seek on progress click
      progress.addEventListener('click', function(e) {
        const rect = progress.getBoundingClientRect();
        const percent = (e.clientX - rect.left) / rect.width;
        audio.currentTime = percent * audio.duration;
      });

      // Reset on end
      audio.addEventListener('ended', function() {
        player.classList.remove('audio-player--playing');
        progressBar.style.width = '0%';
        currentTimeEl.textContent = '0:00';
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["member-horoscopes"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const saveBtn = document.querySelector('[data-save-signs]');
    const statusEl = document.querySelector('[data-save-status]');
    const editBtn = document.querySelector('[data-toggle-edit]');
    const selectorGrid = document.querySelector('[data-selector-grid]');

    // Helper: Set cookie with 365 day expiry
    function setCookie(name, value, days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      const expires = "expires=" + date.toUTCString();
      document.cookie = name + "=" + value + ";" + expires + ";path=/;SameSite=Lax";
    }

    // Helper: Get cookie value
    function getCookie(name) {
      const nameEQ = name + "=";
      const cookies = document.cookie.split(';');
      for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i].trim();
        if (cookie.indexOf(nameEQ) === 0) {
          return cookie.substring(nameEQ.length);
        }
      }
      return null;
    }

    // Load saved signs from cookies on page load
    function loadSavedSigns() {
      const savedSun = getCookie('user_sun_sign');
      const savedMoon = getCookie('user_moon_sign');
      const savedRising = getCookie('user_rising_sign');

      // Populate dropdowns
      if (savedSun) {
        const sunSelect = document.querySelector('[data-sign-field="sun_sign"]');
        if (sunSelect) sunSelect.value = savedSun;
      }
      if (savedMoon) {
        const moonSelect = document.querySelector('[data-sign-field="moon_sign"]');
        if (moonSelect) moonSelect.value = savedMoon;
      }
      if (savedRising) {
        const risingSelect = document.querySelector('[data-sign-field="rising_sign"]');
        if (risingSelect) risingSelect.value = savedRising;
      }
    }

    // Load signs on page load
    loadSavedSigns();

    if (saveBtn) {
      saveBtn.addEventListener('click', async function() {
        const sunSign = document.querySelector('[data-sign-field="sun_sign"]')?.value || '';
        const moonSign = document.querySelector('[data-sign-field="moon_sign"]')?.value || '';
        const risingSign = document.querySelector('[data-sign-field="rising_sign"]')?.value || '';

        saveBtn.disabled = true;
        statusEl.textContent = 'Saving...';
        statusEl.className = 'member-horoscopes__save-status';

        try {
          // TEMPORARY: Save to cookies (365 day expiry)
          // TODO: Custom app will save to customer metafields via Shopify API
          setCookie('user_sun_sign', sunSign, 365);
          setCookie('user_moon_sign', moonSign, 365);
          setCookie('user_rising_sign', risingSign, 365);

          statusEl.textContent = 'Saved! Your signs are stored locally.';
          statusEl.className = 'member-horoscopes__save-status member-horoscopes__save-status--success';

          // Update Overview tab if it exists
          setTimeout(() => {
            const overviewTab = document.querySelector('[data-tab="overview"]');
            if (overviewTab) {
              overviewTab.click(); // Switch to overview to show saved signs
            }
            saveBtn.disabled = false;
          }, 1500);
        } catch (error) {
          statusEl.textContent = 'Error saving. Please try again.';
          statusEl.className = 'member-horoscopes__save-status member-horoscopes__save-status--error';
          saveBtn.disabled = false;
        }
      });
    }

    if (editBtn && selectorGrid) {
      editBtn.addEventListener('click', function() {
        selectorGrid.classList.toggle('member-horoscopes__selector-grid--compact');
        this.textContent = selectorGrid.classList.contains('member-horoscopes__selector-grid--compact')
          ? 'Edit Signs'
          : 'Done';
      });
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["member-overview"] && !Shopify.designMode) return;
  try {
    // Handle tab link clicks within overview
  document.addEventListener('DOMContentLoaded', function() {
    const tabLinks = document.querySelectorAll('[data-tab-link]');

    tabLinks.forEach(link => {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        const targetTab = this.getAttribute('data-tab-link');
        const tabButton = document.querySelector(`[data-tab="${targetTab}"]`);
        if (tabButton) {
          tabButton.click();
        }
      });
    });

    // TEMPORARY: Load signs from cookies and display them
    function getCookie(name) {
      const nameEQ = name + "=";
      const cookies = document.cookie.split(';');
      for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i].trim();
        if (cookie.indexOf(nameEQ) === 0) {
          return cookie.substring(nameEQ.length);
        }
      }
      return null;
    }

    function capitalize(str) {
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    }

    // Check for saved signs in cookies
    const savedSun = getCookie('user_sun_sign');
    const savedMoon = getCookie('user_moon_sign');
    const savedRising = getCookie('user_rising_sign');

    if (savedSun || savedMoon || savedRising) {
      // Hide "no signs" message and button
      const noSignsMsg = document.querySelector('[data-no-signs-message]');
      const noSignsBtn = document.querySelector('[data-no-signs-button]');
      if (noSignsMsg) noSignsMsg.style.display = 'none';
      if (noSignsBtn) noSignsBtn.style.display = 'none';

      // Show signs display and populate values
      const signsDisplay = document.querySelector('[data-signs-display]');
      const hasSignsLink = document.querySelector('[data-has-signs-link]');

      if (signsDisplay) {
        signsDisplay.style.display = 'flex';

        // Update sign values
        if (savedSun) {
          const sunValue = document.querySelector('[data-sign-value="sun"]');
          const sunItem = document.querySelector('[data-sign-item="sun"]');
          if (sunValue) sunValue.textContent = capitalize(savedSun);
          if (sunItem) sunItem.style.display = 'flex';
        }
        if (savedMoon) {
          const moonValue = document.querySelector('[data-sign-value="moon"]');
          const moonItem = document.querySelector('[data-sign-item="moon"]');
          if (moonValue) moonValue.textContent = capitalize(savedMoon);
          if (moonItem) moonItem.style.display = 'flex';
        }
        if (savedRising) {
          const risingValue = document.querySelector('[data-sign-value="rising"]');
          const risingItem = document.querySelector('[data-sign-item="rising"]');
          if (risingValue) risingValue.textContent = capitalize(savedRising);
          if (risingItem) risingItem.style.display = 'flex';
        }
      }

      if (hasSignsLink) {
        hasSignsLink.style.display = 'inline';
      }
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["member-portal-tabs"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const tabsContainer = document.querySelector('[data-member-tabs]');
    if (!tabsContainer) return;

    const tabs = tabsContainer.querySelectorAll('[data-tab]');
    const panels = document.querySelectorAll('[data-tab-panel]');

    tabs.forEach(tab => {
      tab.addEventListener('click', function() {
        const targetTab = this.getAttribute('data-tab');

        // Update tab states
        tabs.forEach(t => {
          t.classList.remove('member-portal-tabs__tab--active');
          t.setAttribute('aria-selected', 'false');
        });
        this.classList.add('member-portal-tabs__tab--active');
        this.setAttribute('aria-selected', 'true');

        // Update panel visibility
        panels.forEach(panel => {
          if (panel.getAttribute('data-tab-panel') === targetTab) {
            panel.classList.remove('member-portal-panel--hidden');
            panel.setAttribute('aria-hidden', 'false');
          } else {
            panel.classList.add('member-portal-panel--hidden');
            panel.setAttribute('aria-hidden', 'true');
          }
        });

        // Update URL hash without scrolling
        history.replaceState(null, null, '#' + targetTab);
      });
    });

    // Handle initial hash
    const hash = window.location.hash.replace('#', '');
    if (hash && document.querySelector(`[data-tab="${hash}"]`)) {
      document.querySelector(`[data-tab="${hash}"]`).click();
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["paywall-block"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.paywall-clear-add-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      if (btn) btn.disabled = true;

      var id = form.querySelector('[name="id"]').value;
      var quantity = form.querySelector('[name="quantity"]') ? form.querySelector('[name="quantity"]').value : '1';
      var sellingPlanInput = form.querySelector('[name="selling_plan"]');
      var properties = {};
      form.querySelectorAll('[name^="properties["]').forEach(function (input) {
        var key = input.name.replace('properties[', '').replace(']', '');
        properties[key] = input.value;
      });

      var cartItem = { id: id, quantity: parseInt(quantity), properties: properties };
      if (sellingPlanInput && sellingPlanInput.value) {
        cartItem.selling_plan = parseInt(sellingPlanInput.value);
      }

      fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(cartItem)
          });
        })
        .then(function () {
          window.location.href = '/checkout';
        })
        .catch(function () {
          if (btn) btn.disabled = false;
        });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yearly-purchase-block"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.ara-yearly-clear-add-form').forEach(function (form) {
    if (form.dataset.araYearlyBound === 'true') return;
    form.dataset.araYearlyBound = 'true';

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var button = form.querySelector('button[type="submit"]');
      var idInput = form.querySelector('[name="id"]');

      if (!idInput || !idInput.value) return;

      if (button) button.disabled = true;

      var properties = {};

      form.querySelectorAll('[name^="properties["]').forEach(function (input) {
        var key = input.name.replace('properties[', '').replace(']', '');
        properties[key] = input.value;
      });

      fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      })
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: idInput.value,
              quantity: 1,
              properties: properties
            })
          });
        })
        .then(function (response) {
          if (!response.ok) throw new Error('Unable to add yearly horoscope.');
          window.location.href = '/checkout';
        })
        .catch(function () {
          if (button) button.disabled = false;
        });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
